import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { useFormContext } from "react-hook-form";
import MyCalendar from "./components/MyCalendar";
import dayjs from "dayjs";

import { getNestedError } from "../../../utils";

const MyDatePicker = (props) => {
  const {
    defaultValue,
    name,
    placeholder = "YYYY-MM-DD",
    dense = false,
    disabled,
    onChange = () => {},
    ...rest
  } = props;

  const {
    trigger,
    register,
    watch,
    setValue,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const selectedValue = watch(name);

  const dropdownRef = useRef(null);

  const [isOpen, setIsOpen] = useState(false);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const handleSelect = (value) => {
    setValue(name, value);
    onChange(value);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    if (defaultValue && !selectedValue) {
      setValue(name, defaultValue);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedValue) trigger(name);
    else clearErrors(name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValue]);

  return (
    <div className="relative" ref={dropdownRef}>
      <input type="hidden" {...register(name)} />

      <div
        onClick={() => (!disabled ? setIsOpen((prev) => !prev) : null)}
        className={`border rounded flex items-center gap-4 justify-between ${
          !dense ? "px-4 h-[56px]" : "px-2 h-9"
        } ${!disabled ? "cursor-pointer bg-white" : "bg-[#F5F5F5]"} text-xl ${
          getNestedError(errors, name)
            ? "border-error"
            : isOpen
            ? "border-primary"
            : "border-gray-border"
        } ${rest.className || ""}`}
        style={{
          transition: "transform 0.2s ease",
        }}
      >
        {selectedValue && dayjs(selectedValue).isValid() ? (
          <span className="text-[#222222]">
            {dayjs(selectedValue).format("YYYY-MM-DD")}
          </span>
        ) : (
          <span className="text-[#888888]">{placeholder}</span>
        )}
        <FontAwesomeIcon icon={faCalendar} className="text-[#888888]" />
      </div>

      {isOpen && !disabled && (
        <div
          className="absolute mt-2 p-2 bg-white rounded w-full max-w-[360px] z-10 border-gray-border border"
          style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.08)" }}
        >
          <MyCalendar
            value={selectedValue}
            onChange={handleSelect}
            onClose={() => setIsOpen(false)}
          />
        </div>
      )}

      {getNestedError(errors, name) && (
        <p className="text-error text-sm mt-1">
          {getNestedError(errors, name)?.message}
        </p>
      )}
    </div>
  );
};

export default MyDatePicker;
